import { useDomain } from "context/DomainContext";
import { useOptionContext } from "context/OptionContext";
import { useCurrentUser } from "context/UserContext";
import i18n from "i18";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { MaterialType, Province } from "types/canvasTypes";

import "./Step.css";

const StepOne = () => {
  const { materialType, setMaterialType } = useOptionContext();
  const { height, setHeight } = useOptionContext();
  const { scale, setScale } = useOptionContext();
  const { province, setProvince } = useOptionContext();
  const { isReseller } = useDomain();
  const { roles } = useCurrentUser();

  const handleMaterialChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setMaterialType(e.target.value as MaterialType);
  };

  const handleHeightChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setHeight(parseInt(e.target.value) as 36 | 42 | 48);
  };
  const handleProvinceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if ((e.target.value as Province) === Province.Ontario)
      i18n.changeLanguage("en");
    else i18n.changeLanguage("fr");
    setProvince(e.target.value as Province);
  };

  const handleScaleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setScale(parseFloat(e.target.value) as 2.9 | 1.5 | 1);
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <h1>{t("firstStep")}</h1>
        <div className="step-actions">
          <Link to={roles.admin ? "/admin" : "/quotations"}>
            <button>{t("quotations")}</button>
          </Link>
        </div>
      </div>
      <div className="custom-dropdown">
        <p>{isReseller ? t("chooseLanguage") : t("chooseProvince")}</p>
        <select
          className="dropdown-select"
          id="provinceSelect"
          value={`${province}`}
          onChange={handleProvinceChange}
        >
          {isReseller ? (
            <>
              <option value="QUEBEC">{t("languageFrench")}</option>
              <option value="ONTARIO">{t("languageEnglish")}</option>
            </>
          ) : (
            <>
              <option value="QUEBEC">QUEBEC</option>
              <option value="ONTARIO">ONTARIO</option>
            </>
          )}
        </select>
      </div>
      <div className="custom-dropdown">
        <p>{t("chooseTheHeightOfGlass")}</p>
        <select
          className="dropdown-select"
          id="heightSelect"
          value={`${height}`}
          onChange={handleHeightChange}
        >
          <option value="48">48"</option>
          <option value="42">42"</option>
          <option value="36">36"</option>
        </select>
      </div>
      <div className="custom-dropdown">
        <p>{t("chooseTheColor")}</p>
        <select
          className="dropdown-select"
          value={materialType}
          onChange={handleMaterialChange}
          id="materialSelect"
        >
          <option value={MaterialType.Silver}>{t("materialTypeSilverLabel")}</option>
          <option value={MaterialType.Black}>{t("materialTypeBlackLabel")}</option>
        </select>
      </div>
      <div className="custom-dropdown">
        <p>{t("chooseTheSizeOfTheProject")}</p>
        <select
          className="dropdown-select"
          onChange={handleScaleChange}
          id="selectedScale"
          value={`${scale}`}
        >
          <option value="2.9">{t("small")} (0 - 200'')</option>
          <option value="1.5">{t("medium")} (200'' - 600'')</option>
          <option value="1">{t("large")} (600''+)</option>
        </select>
      </div>
    </div>
  );
};
export default StepOne;
